module.exports = __webpack_public_path__ + "img/HomeDviewLogo.47d3d980.png";